import { isArray } from '@nzyme/utils/array/isArray.js';
export function getChatNextEventSeq(chat) {
    if (!chat) {
        return 0;
    }
    if (isArray(chat)) {
        const lastEvent = chat[chat.length - 1];
        if (!lastEvent) {
            return 0;
        }
        return lastEvent.seq + 1;
    }
    return chat.seq + 1;
}
//# sourceMappingURL=getChatNextEventSeq.js.map